export default __webpack_public_path__ + "static/media/waste-management-black-icon.db292100.svg";